<template>
    <b-card v-if="coverageCollectingRate">

      <div class="row text-center py-md-2 py-0 h-100">
        <!-- KPI 2 -->
        <div v-if="totalsData" class="col-md-4 col-12 kpi-column">
          <div class="kpi-value">
            {{ totalsData.totalScanAsString }}
          </div>
          <div class="kpi-subtitle">
            {{ $t('campaign.card.totalScan') }}
          </div>
        </div>

        <!-- KPI 3 -->
        <div v-if="totalsData" class="col-md-4 col-12 kpi-divider kpi-column">
          <div class="kpi-value">
            {{ totalsData.totalScanUniqueAsString || '-' }}
          </div>
          <div class="kpi-subtitle">
            {{ $t('campaign.card.totalScanUnique') }}
          </div>
        </div>

        <!-- KPI 1 -->
        <div class="col-md-4 col-12 p-2 kpi-divider kpi-column">
          <h6 class="kpi-title">
            {{ $t('campaign.card.coverageCollectingRate') }}
          </h6>

          <div class="kpi-value">
            {{ coverageCollectingRate.coverageRateAsString || '0%' }}
          </div>

          <div class="kpi-subtitle">
            Données collectées / QR codes scannés
          </div>
        </div>

      </div>

    </b-card>
</template>


<script>

export default {
  props: {
    coverageCollectingRate: {
      type: Object,
      default: () => null,
    },
    totalsData: {
      type: Object,
      default: () => null,
    },
  },
};
</script>

<style scoped>
.card {
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
}

.kpi-divider {
  border-left: none;
  border-top: 1px solid #e5e7eb;
  margin-top: 10px;
}

@media (min-width: 768px) {
  .kpi-divider {
    border-left: 1px solid #e5e7eb;
    border-top: none;
    margin-top: 0;
  }
}

.kpi-title {
  font-size: 0.75rem;
  font-weight: 600;
  color: #1d3266;
  text-transform: uppercase;
  margin-bottom: 6px;
}

.kpi-value {
  font-size: 2rem;
  font-weight: 700;
  color: #1d3266;
  line-height: 1.2;
}

.kpi-subtitle {
  font-size: 0.75rem;
  color: #6b7280;
}

.kpi-column {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

</style>
